(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["homepage-instagram"] && !Shopify.designMode) return;
  try {
    
(function () {
  var widget = document.querySelector('.instagram-section');
  if (!widget) return;

  var posts = Array.prototype.slice.call(widget.querySelectorAll('.post'));
  var modal = widget.querySelector('.instagram-modal');
  var modalImageContainer = widget.querySelector('.modal-post .image-container');
  var modalDesc = widget.querySelector('#post_description');
  var btnPrev = widget.querySelector('.post-back');
  var btnNext = widget.querySelector('.post-forward');
  var btnClose = widget.querySelector('.post-close');
  var currentIndex = -1;
  var keydownBound = false;

  function getDataAttr(node, name) {
    if (!node) return '';
    var value = node.getAttribute(name);
    return value == null ? '' : value;
  }

  function renderModal(index) {
    var post = posts[index];
    if (!post || !modalImageContainer) return;
    var small = getDataAttr(post, 'data-image-sm');
    var medium = getDataAttr(post, 'data-image-md');
    var large = getDataAttr(post, 'data-image') || medium;
    var alt = getDataAttr(post, 'data-alt');
    var desc = getDataAttr(post, 'data-description');

    modalImageContainer.innerHTML =
      '<picture>' +
        '<source media="(max-width: 400px)" srcset="' + small + '">' +
        '<source media="(max-width: 768px)" srcset="' + medium + '">' +
        '<source media="(min-width: 768px)" srcset="' + large + '">' +
        '<img loading="lazy" decoding="async" alt="' + alt + '" src="' + medium + '">' +
      '</picture>';
    if (modalDesc) modalDesc.textContent = desc;
  }

  function openModal(index) {
    currentIndex = index;
    renderModal(index);
    if (modal) {
      modal.hidden = false;
    }
    bindKeydown();
  }

  function closeModal() {
    if (modal) modal.hidden = true;
    currentIndex = -1;
    unbindKeydown();
  }

  function showPrev() {
    if (posts.length === 0) return;
    currentIndex = (currentIndex - 1 + posts.length) % posts.length;
    renderModal(currentIndex);
  }

  function showNext() {
    if (posts.length === 0) return;
    currentIndex = (currentIndex + 1) % posts.length;
    renderModal(currentIndex);
  }

  function handleKeydown(event) {
    if (event.key === 'ArrowLeft') showPrev();
    if (event.key === 'ArrowRight') showNext();
    if (event.key === 'Escape') closeModal();
  }

  function bindKeydown() {
    if (keydownBound) return;
    document.addEventListener('keydown', handleKeydown);
    keydownBound = true;
  }

  function unbindKeydown() {
    if (!keydownBound) return;
    document.removeEventListener('keydown', handleKeydown);
    keydownBound = false;
  }

  var i;
  for (i = 0; i < posts.length; i += 1) {
    (function (index) {
      var post = posts[index];
      post.addEventListener('click', function () { openModal(index); });
      post.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          openModal(index);
        }
      });
    })(i);
  }

  if (btnPrev) {
    btnPrev.addEventListener('click', function (e) { e.stopPropagation(); showPrev(); });
  }
  if (btnNext) {
    btnNext.addEventListener('click', function (e) { e.stopPropagation(); showNext(); });
  }
  if (btnClose) {
    btnClose.addEventListener('click', function (e) { e.stopPropagation(); closeModal(); });
  }
  if (modal) {
    modal.addEventListener('click', closeModal);
  }

})();

  } catch(e) { console.error(e); }
})();
})();
